import React from 'react';

function M2(props){
    let grid = [];

    props.data.contentText.forEach((item)=>{
        grid.push(
            <div className="m2_grid_item c2 -variant-1" key={item.id}>
                <figure className="c2_figure">
                    <a href={item.ctaLink} title={item.ctaText}>
                        <img className="c2_figure_image"
                             src={item.image.file.url}
                             alt={item.image.description}
                             title={item.image.title}
                        />
                    </a>
                </figure>
                <a href={item.ctaLink} title={item.ctaText} className="c2_cta">{item.ctaText}</a>
            </div>
        );
    });

    const output = <section className="m2">
        <div className="container">
            <header className="m2_header c1">
                <h1 className="c1_headline">{props.data.title}</h1>
                <h2 className="c1_subheadline">{props.data.subtitle}</h2>
            </header>
            <div className="m2_grid">
                {grid}
            </div>
        </div>
    </section>;

    return (output)
}

export default M2;
